var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'menu-btn': true, active: _vm.active, dark: _vm.dark, simple: _vm.simple },on:{"click":_vm.handleClick}},[_vm._m(0),(!_vm.simple)?_c('div',{staticClass:"text"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"line line-1"}),_c('div',{staticClass:"line line-2"}),_c('div',{staticClass:"line line-3"})])
}]

export { render, staticRenderFns }